import { createSelector } from "reselect";

const SiteSelector = (state) => state.site;

export const DevicesSelector = createSelector(
  [SiteSelector],
  (site) => site.devices
);

export const SelectedDeviceSelector = createSelector([SiteSelector], (site) =>
  site.selectedDevice.split("").slice(1).join("")
);

export const MapDisplaySelector = createSelector(
  [SiteSelector],
  (site) => site.mapDisplay
);

export const MapOptionSelector = createSelector(
  [SiteSelector],
  (site) => site.mapOption
);

export const HistorySelector = createSelector(
  [SiteSelector],
  (site) => site.history
);
